export const MAP_V2_REDUCER_NAMES = {
  MAP: 'map',
  TABS: 'tabs',
};
